import React, { useState } from 'react';
import ButtonComponent from '../General/Button';
import { useDispatch, useSelector } from 'react-redux';
import { setProjectDetails } from '../../store/createProjectState';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import tr from 'date-fns/locale/tr';

registerLocale('tr', tr);

export function ProCreateDetailsComponent() {
  const dispatch = useDispatch();
  const { projectDetails } = useSelector((state) => state.createProjectState);
  const [endDate, setEndDate] = useState(projectDetails.penddate ? new Date(projectDetails.penddate * 1000) : null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(setProjectDetails({ [name]: value }));
  };

  const handleDateChange = (date) => {
    setEndDate(date);
    const timestamp = date ? Math.floor(date.getTime() / 1000) : null;
    dispatch(setProjectDetails({ penddate: timestamp }));
  };

  return (
    <div className="flex justify-center items-center">
      <div className="flex-col my-4">
        <div className="flex justify-center text-[20px] font-semibold text-gray-39 dark:text-darkWhite-300">
          Proje Detayları
        </div>
        <div className="flex justify-center text-l font-light opacity-50 text-gray-39 dark:text-darkWhite-300">
          Opsiyonel bilgileri ekleyerek projenizi daha iyi yönetin.
        </div>
        
        <div className="flex space-y-1 flex-col my-5">
          {/* Bütçe */}
          <p className="text-[13px] opacity-60 text-gray-950 font-semibold dark:text-gray-100 ml-1 mb-2">
            Proje Bütçesi (Opsiyonel)
          </p>
          <div className="flex w-[500px] h-[60px] justify-center items-center border-2 rounded-2xl bg-white dark:bg-dark-500 mb-4 dark:border-dark-500">
            <input
              className="flex w-full text-center px-3 justify-center items-center outline-none border-none opacity-70 border-1 rounded-2xl dark:bg-dark-500"
              type="text"
              name="pbudget"
              value={projectDetails.pbudget}
              onChange={handleInputChange}
              placeholder="Örn: 50000"
            />
          </div>


          {/* Bitiş Tarihi */}
          <p className="text-[13px] opacity-60 text-gray-950 font-semibold dark:text-gray-100 ml-1 mb-2">
            Tahmini Bitiş Tarihi (Opsiyonel)
          </p>
          <div className="flex w-[500px] h-[60px] justify-center items-center border-2 rounded-2xl bg-white dark:bg-dark-500 mb-4 dark:border-dark-500">
            <DatePicker
              selected={endDate}
              onChange={handleDateChange}
              dateFormat="dd/MM/yyyy"
              locale="tr"
              placeholderText="Bitiş tarihini seçin"
              className="flex w-full text-center px-3 justify-center items-center outline-none border-none opacity-70 rounded-2xl dark:bg-dark-500 h-full"
              minDate={new Date()}
            />
          </div>
          <p className="text-[10px] opacity-60 font-light text-[#a2a5b9] dark:text-gray-100 ml-1">
            Bu bilgiler daha sonra da güncellenebilir
          </p>
        </div>

        <div className="flex justify-center space-x-2 bg-white w-full mx-auto p-4 rounded-2xl dark:bg-dark-500">
          <ButtonComponent
            href="/projects/create"
            title={'Geri'}
            bgcolor="bg-gray-100 text-black rounded-xl w-44 dark:bg-dark-300 dark:text-gray-300 hover:bg-stone-200 border-2 dark:border-dark-500 dark:hover:border-violet-500"
          />
          <ButtonComponent
            href="/projects/create/check"
            title={'İleri'}
            bgcolor="bg-red-600 rounded-xl text-white w-44 dark:bg-violet-500 hover:bg-violet-500"
          />
        </div>
      </div>
    </div>
  );
}

export default ProCreateDetailsComponent;
